import "./btn.css"

import Icon from "@utilities/Icon"
import classNames from "classnames"
import React, { forwardRef } from "react"

import { BaseButton, BaseButtonElementProps } from "./BaseButton"

export type DropdownButtonProps = {
  /** ID of the element controlled by this dropdown button. */
  "aria-controls": string
  /** Whether the dropdown is expanded or not. */
  "aria-expanded": boolean
  suffix?: never
}

export function dropdownProps({ className }: { className?: string }) {
  return {
    className: classNames(className, "tds-btn--dropdown"),
    suffix: <Icon symbol="general#down-caret" aria-hidden />,
  }
}

export const DropdownButton = forwardRef<
  HTMLButtonElement,
  BaseButtonElementProps & DropdownButtonProps
>((props, ref) => {
  return <BaseButton ref={ref} {...props} {...dropdownProps(props)} />
})

DropdownButton.displayName = "DropdownButton"
